import { render, staticRenderFns } from "./application-main.vue?vue&type=template&id=0f570cb7"
import script from "./application-main.vue?vue&type=script&lang=js"
export * from "./application-main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports